import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";
import { useQuote } from "../context/QuoteContext";
import { CONTACT } from "../data/products";

export default function Footer() {
  const { openQuote } = useQuote();
  return (
    <footer className="bg-[#0A1128] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-white/10 pb-16">
          <div className="md:col-span-5">
            <img src="/clinixport-logo.png" alt="Clinixport Global" className="h-12 w-auto bg-white/95 p-2 rounded-sm inline-block" />
            <p className="mt-6 text-white/60 leading-relaxed max-w-sm text-[15px]">
              Medical equipment, healthcare and hygiene supply for environments where
              cleanliness, quality and reliability cannot be compromised.
            </p>
            <button
              onClick={() => openQuote()}
              data-testid="footer-request-quote"
              className="mt-8 inline-flex bg-[#1F6FEB] hover:bg-[#1556B8] transition-colors text-white px-7 py-3.5 font-bold text-xs tracking-widest uppercase"
            >
              Request a Quote
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#38bdf8] mb-5">Navigate</h4>
            <ul className="space-y-3 text-white/70">
              {[["Home", "/"], ["Products", "/products"], ["Industries", "/industries"], ["About Us", "/about"], ["Our Clients", "/clients"], ["Contact", "/contact"]].map(([l, to]) => (
                <li key={to}><Link to={to} className="hover:text-white transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#38bdf8] mb-5">Contact</h4>
            <ul className="space-y-3 text-white/70 text-[15px]">
              <li><a href={`tel:${CONTACT.phoneHref}`} className="flex items-center gap-3 hover:text-white transition-colors"><Phone size={16} className="text-[#38bdf8] shrink-0" /> {CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white transition-colors"><Mail size={16} className="text-[#38bdf8] shrink-0" /> {CONTACT.email}</a></li>
              <li><a href={`https://wa.me/${CONTACT.whatsappHref}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors"><MessageCircle size={16} className="text-[#38bdf8] shrink-0" /> WhatsApp</a></li>
              <li><a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors"><Instagram size={16} className="text-[#38bdf8] shrink-0" /> {CONTACT.instagramHandle}</a></li>
            </ul>
            <address className="mt-5 not-italic text-white/50 text-sm leading-relaxed">
              {CONTACT.address.map((l) => <span key={l} className="block">{l}</span>)}
            </address>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-white/40 text-xs">
          <p>© {new Date().getFullYear()} Clinixport Global. All rights reserved.</p>
          <p className="tracking-wide">Cleanliness · Quality · Reliability · Trust</p>
        </div>
      </div>
    </footer>
  );
}
